// Toddler mode — a per-device lock that turns a shared iPad into a
// "check-ins only" kiosk for one specific kid. When ON:
//   • All header controls are hidden (Settings, Calendar, Chores, Display, Sign-out)
//   • Only the pinned member's card is tappable for check-in
//   • Other member cards remain visible (so the toddler sees their family)
//     but are visually softened and ignore taps
//   • A small discreet unlock button re-opens normal mode after family PIN
//
// Stored per-device in localStorage — the lock travels with the browser, not
// the family, so Dad's phone can stay unlocked while the kitchen iPad is kid-proofed.

const KEY = "famfeel_toddler_mode";

/** Returns the pinned member id if toddler mode is on, or null. */
export function getToddlerMemberId() {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function setToddlerMemberId(memberId) {
  if (!memberId) return;
  try {
    localStorage.setItem(KEY, memberId);
  } catch {}
}

export function clearToddlerMode() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}

export function isToddlerMode() {
  return !!getToddlerMemberId();
}
